import {LanguageModel} from './language.model';
import {UserModel} from './user.model';
import {CodebookModel} from './codebook.model';
import {AuthorModel} from './author.model';

export class PublicationPageAbleModel {
    totalItems: number;
    items: PublicationModel[]=[];
}

export class PublicationSaveModel {
    id: number;
    thematicGroupTypeId:number;
    bindingTypeId: number;
    documentTypeId: number;
    title: string;
    subtitle: string;
    pages: number;
    year: number;
    edition: string;
    link: string;
    isbnId?: number;
    authors: AuthorModel[] = [];
    languages: number[]=[];
    comment:string;
    printCount:number;
    estimatedPrintDeliveryDate:Date;
    constructor(publication:PublicationModel) {
        this.thematicGroupTypeId=publication.thematicGroupType.id;
        this.bindingTypeId=publication.bindingType.id;
        this.documentTypeId=publication.documentType.id;
        this.title=publication.title;
        this.subtitle=publication.subtitle;
        this.pages=publication.pages;
        this.year=publication.year;
        this.edition=publication.edition;
        this.authors.push(...publication.authors);
        this.languages.push(...publication.languages.map(language=>language.id));
        this.comment=publication.comment;
        this.printCount=publication.printCount;
        this.estimatedPrintDeliveryDate=publication.estimatedPrintDeliveryDate;
        this.link=publication.link;
    }

}
export class PublicationModel {
    id: number;
    thematicGroupType: CodebookModel= new CodebookModel();
    bindingType: CodebookModel= new CodebookModel();
    documentType: CodebookModel= new CodebookModel();
    // categoryTypeId?: number;
    thematicGroupTypeId?: number;
    bindingTypeId?: number;
    documentTypeId?: number;
    title: string;
    subtitle: string;
    printCount:number;
    comment:string;
    pages: number;
    year: number;
    edition: string;
    isbn='';
    link='';
    createdDatetime= new Date();
    aplicant:UserModel=new UserModel();
    authors: UserModel []=[];
    languages: LanguageModel[]=[];
    /**
     *  State 1 = new
     *  State 2 = Wait for prints
     *  state 3 = completed
     *  state 4 = isbn removed
     *  state 5 = cancled
     */
    state:number;
    createdDate:Date = new Date();
    isReminderSent:boolean;
    estimatedPrintDeliveryDate:Date = new Date();
    isPrintDelivered:boolean
}




// WEBPACK FOOTER //
// ./src/app/+app-custom/models/publication.model.ts